import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Join to Build Your Dream Houses
        </p>
        <p className='footer-subscription-text'>
          You can Contact us any Time
        </p>
        <div className='input-areas'>
            <Button buttonStyle='btn--outline'>Send Message</Button>
        </div>
      </section>
      
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              <img src='images/Ba-1.png' alt="Build Angles Logo" style={{ height: '70px', width:'70px',marginRight: '10px' }} />
              Build Angles
            </Link>
          </div>
          <small class='website-rights'>Build Angles Engineering (PVT)Ltd Since 2017</small>
          <div class='social-icons'>
            <a
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
              component='a'
              href='https://web.facebook.com/buildangless?_rdc=1&_rdr'
              rel='noopener noreferrer'
              >
                <i class='fab fa-facebook-f' />
              </a>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i class='fab fa-youtube' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='Twitter'
            >
              <i class='fab fa-twitter' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
